export default {
    computed:{
        currencyFormat(){
            return v => v ? v.toLocaleString('es-AR', {style:'currency', currency:'ARS'}).replace(',00','') : v
        }
    }
}
